import { Record } from 'immutable';

import { ShareParticipant } from './ShareParticipant';

class Share extends Record(
  {
    id: null,
    shareableId: null,
    shareableType: null,
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null,
    deletedAt: null,
    deletedBy: null,
    participants: null
  },
  'Share'
) {
  constructor(props) {
    super({
      ...props,
      participants: props?.participants?.map((participant) => new ShareParticipant(participant))
    });
  }

  participant(userId) {
    return this.participants.find((participant) => participant.userId === userId);
  }
}

export { Share };
